import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fontSize.svg",
  "use": "fontSize.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"fontSize.svg\"><path d=\"M3.5 4C3.22386 4 3 4.22386 3 4.5C3 4.77614 3.22386 5 3.5 5H9V19.5C9 19.7761 9.22386 20 9.5 20C9.77614 20 10 19.7761 10 19.5V5H15.5C15.7761 5 16 4.77614 16 4.5C16 4.22386 15.7761 4 15.5 4H3.5Z\" /><path d=\"M13.5 12C13.2239 12 13 12.2239 13 12.5C13 12.7761 13.2239 13 13.5 13H16V19.5C16 19.7761 16.2239 20 16.5 20C16.7761 20 17 19.7761 17 19.5V13H19.5C19.7761 13 20 12.7761 20 12.5C20 12.2239 19.7761 12 19.5 12H13.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol